import {
  COUNTRY_CODE_ES,
  COUNTRY_CODE_PT,
  COUNTRY_CODE_DE,
  COUNTRY_CODE_FR,
  COUNTRY_CODE_NL,
} from 'commonsConstants/countryCodes';
import { translateText } from '../../../getTranslationsMyProfileUploadDocumentation';

export const OTHER_OPTION_ID = 'EN157';

const availableForOnlySpain = [COUNTRY_CODE_ES];
const availableForAllCountries = [
  COUNTRY_CODE_ES,
  COUNTRY_CODE_PT,
  COUNTRY_CODE_DE,
  COUNTRY_CODE_FR,
  COUNTRY_CODE_NL,
];
const comboTranslationKey = 'comboOption';

const processOptions = [
  {
    value: 'EN163',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForAllCountries,
    confidential: false,
  },
  {
    value: 'EN155',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN158',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForAllCountries,
    confidential: false,
  },
  {
    value: 'EN153',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForAllCountries,
    confidential: true,
  },
  {
    value: 'EN150',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN149',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN156',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN154',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForAllCountries,
    confidential: false,
  },
  {
    value: 'EN186',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN148',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN152',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN151',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForAllCountries,
    confidential: false,
  },
  {
    value: 'EN162',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN160',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN161',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForAllCountries,
    confidential: true,
  },
  {
    value: 'EN174',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForAllCountries,
    confidential: false,
  },
  {
    value: 'EN175',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForAllCountries,
    confidential: false,
  },
  {
    value: 'EN176',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN177',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN178',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForOnlySpain,
    confidential: false,
  },
  {
    value: 'EN184',
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForAllCountries,
    confidential: false,
  },
];

const otherOption = [
  {
    value: OTHER_OPTION_ID,
    get label() {
      return translateText(`${comboTranslationKey}_${this.value}`);
    },
    availableCountries: availableForAllCountries,
    confidential: false,
  },
];

export const getProcessOptions = originCountry => {
  return processOptions
    .sort((a, b) => {
      const nameA = a.label.toUpperCase();
      const nameB = b.label.toUpperCase();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    })
    .filter(option => option.availableCountries.includes(originCountry))
    .concat(otherOption);
};
